import { UseQueryResult } from 'react-query';
import { useMyQuery, QueryInfos, Options } from '../helpers';
import {
    GetLocationInput,
    GetClosestLocationInput,
    GetPointsOfInterestInput,
    GetClosestLocationV2Input,
} from '../../apiTypes';
import { STALETIME_AUTOCOMPLETE } from '../../../utils/constants';
import { typeGeolocation } from './types';

const searchLocationAutoComplete = (variables?: GetLocationInput): QueryInfos => {
    const { id = '', ...rest } = variables;
    return {
        name: `geolocation-search-autocomplete${id}`,
        path: '/geolocation/addresses/autocomplete',
        type: typeGeolocation.GET_AUTOCOMPLETE,
        params: {
            ...rest,
        },
    };
};

const searchLocationClosestQuery = (variables: GetClosestLocationInput | GetClosestLocationV2Input): QueryInfos => {
    const mode = 'placeId' in variables ? variables.placeId : 'closest';
    return {
        name: 'geolocation-search-closest',
        path: `/geolocation/addresses/${mode}`,
        type: typeGeolocation.GET_CLOSEST,
        params: {
            ...variables,
        },
    };
};

const getPointsOfInterest = (variables?: GetPointsOfInterestInput): QueryInfos => {
    return {
        name: 'geolocation-get-points-of-interest',
        path: '/geolocation/points-of-interest',
        type: typeGeolocation.GET_POINT_OF_INTEREST,
        params: {
            ...variables,
        },
    };
};

export function useGetAutoCompleteAddresses<T>(options: Options<GetLocationInput>): UseQueryResult<T, Error> {
    return useMyQuery<T, GetLocationInput>(searchLocationAutoComplete, {
        staleTime: STALETIME_AUTOCOMPLETE,
        ...options,
    });
}

export function useGetSearchClosestAddress<T>(
    options: Options<GetClosestLocationInput | GetClosestLocationV2Input>,
): UseQueryResult<T, Error> {
    return useMyQuery<T, GetClosestLocationInput | GetClosestLocationV2Input>(searchLocationClosestQuery, options);
}

export function useGetPOITrains<T>(): UseQueryResult<T, Error> {
    return useMyQuery<T>(getPointsOfInterest, {
        staleTime: STALETIME_AUTOCOMPLETE,
        select: (data) => data.stations,
    });
}
export function useGetPOIPlanes<T>(): UseQueryResult<T, Error> {
    return useMyQuery<T>(getPointsOfInterest, {
        staleTime: STALETIME_AUTOCOMPLETE,
        select: (data) => data.airports,
    });
}
export function useGetPOIOthers<T>(): UseQueryResult<T, Error> {
    return useMyQuery<T>(getPointsOfInterest, {
        staleTime: STALETIME_AUTOCOMPLETE,
        select: (data) => data.others,
    });
}
